// useForm.js

import { addAssessmentScanData, getAssessmentScanData } from '../../Service/ApiService';
import React, { useEffect } from 'react';
import BarcodeMaterialItem from '../Model/BarcodeMaterialItem';
// import { useNavigate } from 'react-router-dom';
import { FABRICUSER, GARMENTUSER } from 'utils/constants';
import { showAlert } from 'utils/ErrorMessage';
import { showSuccessAlert } from 'utils/SuccessMessage';
const BarcodeAssessmentController = () => {
  // const navigate=useNavigate();
  const [barcode, setBarcodText] = React.useState('');
  const [barcodeerror, setBarcodErrorText] = React.useState('');
  const [isData, setIsData] = React.useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const [materialDataList, setMaterialDataList] = React.useState([]);
  const getBarcode = async (inputValue) => {
    try {
      setIsData(true);
      let trimmedInputValue = inputValue.trim();
      if (trimmedInputValue.endsWith(',')) {
        trimmedInputValue = trimmedInputValue.slice(0, -1); // Remove trailing comma
      }

      const response = await getAssessmentScanData(trimmedInputValue, user.userVerticalId);
      console.log('Return Response:', response);

      if (response && response.success === 'true' && Array.isArray(response.materialList) && response.materialList.length > 0) {
        const reversedBarcodeArray = trimmedInputValue.split(',').reverse();

        const sortedResponseMaterialList = response.materialList.slice().sort((a, b) => {
          const sizeAString = a.sizex.toString();
          const sizeBString = b.sizex.toString();

          if (sizeAString.length !== sizeBString.length) {
            return sizeBString.length - sizeAString.length;
          } else {
            return parseFloat(b.sizex) - parseFloat(a.sizex);
          }
        });

        const combinedMaterialList = [...sortedResponseMaterialList];

        const sortedMaterialList = combinedMaterialList.sort((a, b) => {
          const indexA = reversedBarcodeArray.indexOf(a.barcode);
          const indexB = reversedBarcodeArray.indexOf(b.barcode);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }

          if (indexA !== -1) {
            return -1;
          }

          if (indexB !== -1) {
            return 1;
          }

          return 0;
        });

        // ✅ Preserve previous qty values
        const previousQtyMap = {};
        materialDataList.forEach((item) => {
          previousQtyMap[item.materialCode] = item.qty;
        });

        const updatedMaterialList = sortedMaterialList.map((item) => {
          const newItem = new BarcodeMaterialItem(item);
          if (previousQtyMap[item.materialCode] !== undefined) {
            newItem.qty = previousQtyMap[item.materialCode];
          }
          return newItem;
        });

        setMaterialDataList(updatedMaterialList);
        localStorage.setItem('barcodenotfoundmaterialList', JSON.stringify(updatedMaterialList));

        setBarcodErrorText('');
        return true;
      } else {
        setBarcodErrorText('No Data Found');
        setMaterialDataList([]);
        setIsData(false);
        return false;
      }
    } catch (error) {
      setIsData(false);
      return false;
    } finally {
      setIsData(false);
    }
  };

  const handleOkButtonClick = () => {
    if (barcode == '') {
      setBarcodErrorText('Please enter barcode');
    } else {
      getData(barcode);
    }
  };

  const handleClearButtonClick = () => {
    setBarcodText('');
    setBarcodErrorText('');
    setMaterialDataList([]);
  };

  // const addToStringList = (newString) => {
  //   return [newString];
  // };

  const getData = async (inputValue) => {
    const barcodes = inputValue.split(',').map((b) => b.trim());
    const duplicates = barcodes.map((item) => item.trim()).filter((item, index, arr) => arr.indexOf(item) !== index);

    if (user.userVerticalId == FABRICUSER && inputValue != '' && inputValue.length >= 7) {
      //setBarcodText(addToStringList(inputValue));
      console.log(inputValue);
      if (duplicates.length > 0) {
        showAlert('Duplicate barcodes detected: ' + duplicates.join(', '), 'Validation');
        setBarcodErrorText('Duplicate barcodes detected.');
      } else {
        await getBarcode(inputValue);
      }
    } else if (user.userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase()) && inputValue != '' && inputValue.length >= 13) {
      //setBarcodText(addToStringList(inputValue));
      if (duplicates.length > 0) {
        showAlert('Duplicate barcodes detected: ' + duplicates.join(', '), 'Validation');
        setBarcodErrorText('Duplicate barcodes detected.');
      } else {
        await getBarcode(inputValue, '', '');
      }
    } else {
      // getBarcode(inputValue);
      setBarcodText(inputValue);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (barcode === '') {
      setBarcodErrorText('Please enter barcode');
      return;
    }
    if (materialDataList.length === 0) {
      setBarcodErrorText('Data not found');
      return;
    }

    const allHaveValidQty = materialDataList.every(
      (item) => typeof item.qty === 'number' && !isNaN(item.qty) && item.qty > 0 && item.qty <= 10
    );

    if (!allHaveValidQty) {
      showAlert('Please select valid assessment!', 'Error');

      return;
    }

    setIsData(true);
    const userCode = user?.userCode;
    const cId = confvalue?.cID;

    const payload = materialDataList.map((item) => ({
      userCode,
      cId,
      barcode: item.barcode,
      materialCode: item.materialCode,
      materialDesc: item.materialDesc,
      chart: item.chart,
      Shade: item.shade,
      assesmentValue: item.qty || 0
    }));

    const payloadjson = JSON.stringify(payload);

    try {
      const response = await addAssessmentScanData(payloadjson);

      console.log('Submit Payload:', payload);
      console.log('Response:', response);

      if (response.success === true || response.success === 'true') {
        let message = `${response.message}.`;

        // Check for existing barcodes and append them to message
        if (response.existing_barcodes && response.existing_barcodes.trim() !== '') {
          message = `\nExisting barcodes:\n${response.existing_barcodes.replace(/,/g, ', ')}`;
        }

        showSuccessAlert(message, 'Success');
        handleClear(); // Optional: Clear after successful insert
      } else {
        showAlert('❌ Failed to save data.', 'Error');
      }
    } catch (error) {
      setIsData(false);
      showAlert('❌ Error occurred while saving.', 'Error');
    } finally {
      setIsData(false);
    }
  };

  const handleClear = async () => {
    setBarcodText('');
    setBarcodErrorText('');
    setMaterialDataList([]);
  };

  useEffect(() => {
    const inputHandler = (event) => handleBarcodeScan(event);
    window.addEventListener('input', inputHandler);
    return () => {
      window.removeEventListener('input', inputHandler);
    };
  }, []);

  const handleBarcodeScan = (event) => {
    const scannedData = event.target.value;
    // console.log('Scanned data:', scannedData);
    let formattedData = scannedData.trim().replace(/\s+/g, ',');
    formattedData = formattedData.replace(/,+/g, ',');
    // console.log(barcode);
    const updatedBarcodeText = barcode ? `${barcode}, ${formattedData}` : formattedData;
    // console.log('updatedBarcodeText:', updatedBarcodeText);
    setBarcodText(updatedBarcodeText);
  };

  const handleChange = (e) => {
    //setMaterialDataList([])
    let inputValue = e.target.value;

    if (inputValue.endsWith('\n')) {
      console.log('its a barcode scan');
      // Append a comma and a space after each complete scan, except for the first one
      inputValue = inputValue.trim(); // Remove leading and trailing whitespace
      if (inputValue !== '') {
        inputValue += ',';
      }
      // getData(inputValue);
      // Clear the textbox after processing
      e.target.value = '';
    }
    // console.log("inputValue===>"+inputValue);
    inputValue = inputValue.trim();
    //if(!inputValue.endsWith(",")){
    setBarcodText(inputValue);
    // }
  };

  // const handlePaste = (event) => {
  // console.log('Paste event detected');
  // const pastedText = event.clipboardData.getData('text');
  // console.log('Pasted text:', pastedText);

  // const formattedText = pastedText.replace(/\s+/g, ',');
  // console.log('Formatted text:', formattedText);
  // getData(formattedText);
  // };

  const handleQtyChange = (materialCode, newQty) => {
    setMaterialDataList((prev) =>
      prev.map((item) =>
        item.materialCode === materialCode
          ? { ...item, qty: parseInt(newQty) } // store selected quantity
          : item
      )
    );
  };

  return {
    isData,
    materialDataList,
    barcode,
    barcodeerror,
    handleOkButtonClick,
    handleClearButtonClick,
    handleSave,
    handleClear,
    handleChange,
    handleQtyChange
  };
};

export default BarcodeAssessmentController;
